import { Link } from "react-router-dom";
import { MessageSquare, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

export interface UnreadInquiriesCalloutProps {
  unreadCount: number;
  className?: string;
}

/**
 * Prominent unread-inquiries strip (AC#3: "visually distinct", "prominent, with quick
 * link") — replaces the current small inline badge treatment. Shared by BOTH the
 * Insights page hero and the dashboard card; deliberately standalone with no
 * page-specific assumptions so either consumer can drop it in as-is.
 */
export function UnreadInquiriesCallout({ unreadCount, className }: UnreadInquiriesCalloutProps) {
  if (unreadCount === 0) return null;

  const noun = unreadCount === 1 ? "inquiry" : "inquiries";

  return (
    <Link
      to="/teacher-inquiries"
      aria-label={`You have ${unreadCount} unread ${noun}. View inquiries.`}
      className={cn(
        "flex items-center justify-between gap-3 rounded-2xl border border-warning/30 bg-warning/10 px-5 py-4",
        "shadow-sm transition-colors motion-safe:duration-200 hover:bg-warning/15",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
        className
      )}
    >
      <span className="flex items-center gap-2.5 text-sm font-semibold text-warning">
        <MessageSquare className="w-4 h-4 shrink-0" aria-hidden="true" />
        You have {unreadCount} unread {noun}
      </span>
      <span className="flex items-center gap-1 text-sm font-medium text-warning shrink-0">
        View
        <ArrowRight className="w-4 h-4" aria-hidden="true" />
      </span>
    </Link>
  );
}

export default UnreadInquiriesCallout;
